module.exports = __webpack_public_path__ + "static/nicholas-brathwaite.d5a21f17.webp";